import React, {useRef} from "react";
import {Modal, Button, Row, Col} from "react-bootstrap";
import SignatureCanvas from "react-signature-canvas";
import ReactSignatureCanvas from "react-signature-canvas";
import styled from "styled-components";
import SuccessButton from '../../organisms/SuccessButton';

export interface ModalFirmaProps {
    mostrar: boolean
    onCancelar: () => void,
    setDataUrl: (dataUrl?: string) => void,
    onLimpiar: () => void,
    onConfirmar: () => void
}

function ModalFirma({mostrar, onCancelar, setDataUrl, onLimpiar, onConfirmar}: ModalFirmaProps) {
    let sigCanvas = useRef({} as ReactSignatureCanvas | null);

    const limpiar = () => {
        sigCanvas.current?.clear();
        onLimpiar();
    }

    return (
        <Modal
            onHide={onCancelar}
            show={mostrar}
            fullscreen={true}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Firma en línea
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col className="justify-content-center">
                        <SignatureRow>
                            <SignatureCanvas ref={sigCanvas} canvasProps={{height: 700}}/>
                        </SignatureRow>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SuccessButton onClick={() => {
                    setDataUrl(sigCanvas.current?.toDataURL());
                    onConfirmar();
                }} variant="success">Confirmar</SuccessButton>
                <Button onClick={limpiar} variant="primary">Limpiar</Button>
                <Button onClick={onCancelar} variant="danger">Cancelar</Button>
            </Modal.Footer>
        </Modal>);
}

const SignatureRow = styled(Row)`
  border: 1px solid #ced4da;
`

export default ModalFirma;